import { __rest } from "tslib";
import styled from "@emotion/styled/macro";
import * as R from "ramda";
import { BUTTON_SIZE } from "../shared/helpers/constants";
import { BUTTON_VARIANT } from "../shared/types";
const getButtonStyles = (_a) => {
    var { size, theme, variant, color, fontSize, fontFamily, isActive, zIndex, iconHoverColor, isLoading, isFullWidth, width, border, borderColor, justifyContent, alignItems, cursor, pointerEvents, maxHeight, minWidth, background, fontWeight, letterSpacing, borderStyle, lineHeight, paddingInlineStart, paddingInlineEnd, height, paddingTop, paddingBottom } = _a, rest = __rest(_a, ["size", "theme", "variant", "color", "fontSize", "fontFamily", "isActive", "zIndex", "iconHoverColor", "isLoading", "isFullWidth", "width", "border", "borderColor", "justifyContent", "alignItems", "cursor", "pointerEvents", "maxHeight", "minWidth", "background", "fontWeight", "letterSpacing", "borderStyle", "lineHeight", "paddingInlineStart", "paddingInlineEnd", "height", "paddingTop", "paddingBottom"]);
    const omittedRest = R.omit(["children", "onClick", "onHover"], rest);
    let style = {};
    style = Object.assign({ zIndex: zIndex, position: "relative", justifyContent: justifyContent ? justifyContent : "center", alignItems: alignItems ? alignItems : "center", display: "flex", cursor: cursor ? cursor : "pointer", width: width ? width : isFullWidth ? "100%" : "auto", borderRadius: theme.colors[variant].borderRadius[size], border: border
            ? border
            : theme.colors[variant].border
                ? theme.colors[variant].border
                : "2.5px solid", borderColor: borderColor
            ? borderColor
            : theme.colors[variant].isTransparentBody
                ? theme.colors[variant].borderColor
                : "transparent", pointerEvents: pointerEvents ? pointerEvents : "auto", maxHeight: maxHeight ? maxHeight : theme.colors[variant].maxHeight[size], minWidth: minWidth ? minWidth : theme.colors[variant].minWidth[size], color: color ? color : theme.colors[variant].mainTextColor, background: background
            ? background
            : theme.colors[variant].isTransparentMain
                ? "transparent"
                : `${theme.colors[variant].main}` +
                    "padding-box," +
                    `${theme.colors[variant].borderColor}` +
                    "border-box", fontSize: fontSize ? fontSize : theme.fontSizes[size], fontFamily: fontFamily ? fontFamily : theme.fonts.primary, fontWeight: fontWeight ? fontWeight : 600, letterSpacing: letterSpacing ? letterSpacing : 1, borderStyle: borderStyle ? borderStyle : "solid", lineHeight: lineHeight ? lineHeight : 1.22, "&:after": isLoading || isActive
            ? ""
            : {
                content: '""',
                background: theme.colors.selected.main,
                height: "50%",
                left: 0,
                opacity: 0.25,
                position: "absolute",
                top: "50%",
                transform: "rotate(-2deg)",
                width: "100%",
                zIndex: 2,
                transition: "all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)",
            }, "&:hover:enabled": {
            transform: "scale(1.05)",
            transition: "all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)",
            textShadow: "1px 1px 0" + theme.colors[variant].activeTextColor
                ? theme.colors[variant].activeTextColor
                : color,
            borderColor: theme.colors[variant].isTransparentHoverBody
                ? theme.colors[variant].hoverBorderColor
                : "transparent",
            color: theme.colors[variant].hoverTextColor ? theme.colors[variant].hoverTextColor : color,
            background: `${theme.colors[variant].hoverColor
                ? theme.colors[variant].hoverColor
                : theme.colors.selected.main}` +
                "padding-box," +
                `${theme.colors[variant].hoverBorderColor}` +
                "border-box",
            svg: {
                color: iconHoverColor ? iconHoverColor : theme.colors[variant].hoverTextColor,
            },
            "&:after": {
                background: theme.colors.selected.hover,
                top: "20%",
                borderRadius: 21,
                transform: "rotate(2deg)",
            },
        }, "&:hover > *": Object.assign({ color: theme.colors[variant].hoverTextColor ? theme.colors[variant].hoverTextColor : color }, rest._hover), "&:disabled": {
            opacity: 0.3,
            borderColor: theme.colors[variant].isTransparentDisableBody
                ? theme.colors[variant].disableBorder
                : "transparent",
            background: `${theme.colors[variant].disableMain}` +
                "padding-box," +
                `${theme.colors[variant].disableBorder}` +
                "border-box",
            color: theme.colors[variant].disableColor ? theme.colors[variant].disableColor : "white",
            "&:hover": {
                background: `${theme.colors[variant].disableMain}` +
                    "padding-box," +
                    `${theme.colors[variant].disableBorder}` +
                    "border-box",
            },
        }, "&:active:enabled": {
            transform: "scale(0.98)",
            color: theme.colors[variant].activeTextColor
                ? theme.colors[variant].activeTextColor
                : "#212121",
            borderColor: theme.colors[variant].isTransparentActiveBody
                ? theme.colors[variant].activeBorderColor
                : "transparent",
            textShadow: "1px 1px 0" + theme.colors[variant].activeTextColor
                ? theme.colors[variant].activeTextColor
                : color,
            "&:after": {
                background: theme.colors.selected.main,
                top: 0,
                transform: "rotate(0deg)",
            },
            background: `${theme.colors[variant].activeColor}` +
                "padding-box," +
                `${theme.colors[variant].activeBorderColor}` +
                "border-box",
            backgroundSize: "auto 110%",
        }, "& > *": {
            zIndex: 3,
        } }, omittedRest);
    switch (size) {
        case BUTTON_SIZE.lg:
            style = Object.assign(Object.assign({}, style), { paddingInlineStart: paddingInlineStart ? paddingInlineStart : 15.3, paddingInlineEnd: paddingInlineEnd ? paddingInlineEnd : 15.3, paddingTop: paddingTop ? paddingTop : 17.51, paddingBottom: paddingBottom ? paddingBottom : 17.51, height: height ? height : 56 });
            break;
        case BUTTON_SIZE.md:
            style = Object.assign(Object.assign({}, style), { paddingInlineStart: paddingInlineStart ? paddingInlineStart : 24.4, paddingInlineEnd: paddingInlineEnd ? paddingInlineEnd : 24.4, height: height ? height : 46 });
            break;
        case BUTTON_SIZE.sm:
            style = Object.assign(Object.assign({}, style), { height: height ? height : 36, paddingInlineStart: paddingInlineStart ? paddingInlineStart : 17.7, paddingInlineEnd: paddingInlineEnd ? paddingInlineEnd : 17.7 });
            break;
        default:
            style = Object.assign(Object.assign({}, style), { height: height ? height : 25 });
            break;
    }
    style = R.omit(theme.colors[variant].omit, style);
    switch (variant) {
        case BUTTON_VARIANT.success:
            style = Object.assign(Object.assign({}, style), { "&:hover:enabled": {
                    background: theme.colors[variant].hoverColor,
                    color: "white",
                } });
            break;
        case BUTTON_VARIANT.dark:
            style = Object.assign({}, style);
            break;
    }
    if (isActive) {
        style = Object.assign(Object.assign({}, style), { transform: "scale(0.98)", color: theme.colors[variant].activeTextColor
                ? theme.colors[variant].activeTextColor
                : "#212121", "&:after": {}, borderColor: theme.colors[variant].isTransparentActiveBody
                ? theme.colors[variant].activeBorderColor
                : "transparent", backgroundSize: "auto 110%", background: `${theme.colors[variant].activeColor}` +
                "padding-box," +
                `${theme.colors[variant].activeBorderColor}` +
                "border-box" });
    }
    return style;
};
export const ButtonStyled = styled.button((props) => R.has("theme", props) && getButtonStyles(props));
export const IconWrapper = styled.div `
  margin-left: ${(props) => props.marginLeft || "8px"};
  margin-right: ${(props) => props.marginRight || "8px"};
`;
